var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "settings" } }, [
    _c(
      "section",
      [
        _c("transition", { attrs: { name: "fade" } }, [
          _vm.showSignOutConfirmation
            ? _c("div", { staticClass: "alertBox" }, [
                _c("div", [
                  _c("h5", [_vm._v("Sign Out")]),
                  _vm._v(" "),
                  _c("p", [_vm._v("Sure you want to sign out?")]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "destructive",
                      on: {
                        click: function($event) {
                          _vm.showSignOutConfirmation = false
                        }
                      }
                    },
                    [_vm._v("No")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      on: {
                        click: function($event) {
                          _vm.showSignOutConfirmation = false
                          _vm.signOut()
                        }
                      }
                    },
                    [_vm._v("Yes")]
                  )
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.showUpdateNameInvalid
            ? _c("div", { staticClass: "alertBox" }, [
                _c("div", [
                  _c("h5", [_vm._v("Change Name")]),
                  _vm._v(" "),
                  _c("p", [_vm._v("Please enter at least a given name.")]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      on: {
                        click: function($event) {
                          _vm.showUpdateNameInvalid = false
                        }
                      }
                    },
                    [_vm._v("OK")]
                  )
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.showUpdateNameSuccess
            ? _c("div", { staticClass: "alertBox" }, [
                _c("div", [
                  _c("h5", [_vm._v("Change Name")]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "Your name was successfully changed to " +
                        _vm._s(_vm.appUser.givenName) +
                        " " +
                        _vm._s(_vm.appUser.familyName) +
                        "."
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      on: {
                        click: function($event) {
                          _vm.showUpdateNameSuccess = false
                        }
                      }
                    },
                    [_vm._v("OK")]
                  )
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.showUpdatePhoneNumberConfirmation
            ? _c("div", { staticClass: "alertBox" }, [
                _c("div", [
                  _c("h5", [_vm._v("Change Phone Number")]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "Are you sure you want to change your phone number? You'll need to login using the new phone number and then be reinvited to any upcoming events."
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "destructive",
                      on: {
                        click: function($event) {
                          _vm.showUpdatePhoneNumberConfirmation = false
                        }
                      }
                    },
                    [_vm._v("No")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      on: {
                        click: function($event) {
                          _vm.showUpdatePhoneNumberConfirmation = false
                          _vm.updateAppUserPhoneNumber()
                        }
                      }
                    },
                    [_vm._v("Yes")]
                  )
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.showUpdatePhoneNumberInvalid
            ? _c("div", { staticClass: "alertBox" }, [
                _c("div", [
                  _c("h5", [_vm._v("Change PhoneNumber")]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "Please enter a 9-digit phone number and applicable country code."
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      on: {
                        click: function($event) {
                          _vm.showUpdatePhoneNumberInvalid = false
                        }
                      }
                    },
                    [_vm._v("OK")]
                  )
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.showUpdatePhoneNumberSuccess
            ? _c("div", { staticClass: "alertBox" }, [
                _c("div", [
                  _c("h5", [_vm._v("Change Phone Number")]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "Your phone number was successfully changed to " +
                        _vm._s(this.phoneNumber) +
                        "."
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      on: {
                        click: function($event) {
                          _vm.showUpdatePhoneNumberSuccess = false
                        }
                      }
                    },
                    [_vm._v("OK")]
                  )
                ])
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("h5", [
          _vm._v(
            "Account (" +
              _vm._s(_vm.appUser.givenName) +
              " " +
              _vm._s(_vm.appUser.familyName) +
              ")"
          )
        ]),
        _vm._v(" "),
        _c(
          "form",
          {
            on: {
              submit: function($event) {
                $event.preventDefault()
              }
            }
          },
          [
            _c(
              "button",
              {
                on: {
                  click: function($event) {
                    _vm.showSignOutConfirmation = true
                  }
                }
              },
              [_vm._v("Sign Out")]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "form",
          {
            on: {
              submit: function($event) {
                $event.preventDefault()
              }
            }
          },
          [
            _c("h5", [_vm._v("Change name")]),
            _vm._v(" "),
            _c("label", { attrs: { for: "givenName" } }, [
              _vm._v("Given Name")
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.trim",
                  value: _vm.givenName,
                  expression: "givenName",
                  modifiers: { trim: true }
                }
              ],
              attrs: {
                type: "text",
                placeholder: _vm.appUser.givenName,
                id: "givenName"
              },
              domProps: { value: _vm.givenName },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.givenName = $event.target.value.trim()
                },
                blur: function($event) {
                  return _vm.$forceUpdate()
                }
              }
            }),
            _vm._v(" "),
            _c("label", { attrs: { for: "familyName" } }, [
              _vm._v("Family Name")
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.trim",
                  value: _vm.familyName,
                  expression: "familyName",
                  modifiers: { trim: true }
                }
              ],
              attrs: {
                type: "text",
                placeholder: _vm.appUser.familyName,
                id: "familyName"
              },
              domProps: { value: _vm.familyName },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.familyName = $event.target.value.trim()
                },
                blur: function($event) {
                  return _vm.$forceUpdate()
                }
              }
            }),
            _vm._v(" "),
            _c(
              "button",
              {
                on: {
                  click: function($event) {
                    return _vm.updateAppUserName()
                  }
                }
              },
              [_vm._v("Update Name")]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "form",
          {
            on: {
              submit: function($event) {
                $event.preventDefault()
              }
            }
          },
          [
            _c("h5", [_vm._v("Change phone number")]),
            _vm._v(" "),
            _c("label", { attrs: { for: "familyName" } }, [
              _vm._v("Phone Number")
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.trim",
                  value: _vm.phoneNumber,
                  expression: "phoneNumber",
                  modifiers: { trim: true }
                }
              ],
              attrs: {
                type: "text",
                placeholder: _vm.appUser.phoneNumber,
                id: "familyName"
              },
              domProps: { value: _vm.phoneNumber },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.phoneNumber = $event.target.value.trim()
                },
                blur: function($event) {
                  return _vm.$forceUpdate()
                }
              }
            }),
            _vm._v(" "),
            _c(
              "button",
              {
                on: {
                  click: function($event) {
                    _vm.showUpdatePhoneNumberConfirmation = true
                  }
                }
              },
              [_vm._v("Update Phone Number")]
            )
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-47aa12d3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47aa12d3","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Settings.vue
// module id = null
// module chunks = 